import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=551a1bd6&scoped=true&"
import script from "./Button.vue?vue&type=script&lang=js&"
export * from "./Button.vue?vue&type=script&lang=js&"
import style0 from "./Button.vue?vue&type=style&index=0&id=551a1bd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551a1bd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('551a1bd6')) {
      api.createRecord('551a1bd6', component.options)
    } else {
      api.reload('551a1bd6', component.options)
    }
    module.hot.accept("./Button.vue?vue&type=template&id=551a1bd6&scoped=true&", function () {
      api.rerender('551a1bd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls2/Button.vue"
export default component.exports